import React, { useEffect, useRef, useState } from 'react';

interface ElevenLabsAudioNativeProps {
  publicUserId: string;
  size?: 'small' | 'large';
  textColor?: string;
  backgroundColor?: string;
}

/**
 * Componente per integrare ElevenLabs Audio Native
 * Forza re-inizializzazione ad ogni mount per funzionare in SPA
 */
const ElevenLabsAudioNative: React.FC<ElevenLabsAudioNativeProps> = ({
  publicUserId,
  size = 'small',
  textColor = 'rgba(0, 0, 0, 1)',
  backgroundColor = 'rgba(255, 255, 255, 1)'
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [widgetId] = useState(() => `elevenlabs-widget-${Date.now()}`);

  useEffect(() => {
    // Rimuovi eventuali script precedenti per forzare re-init
    const oldScripts = document.querySelectorAll('script[src*="audioNativeHelper"]');
    oldScripts.forEach(s => s.remove());

    // Crea nuovo script
    const script = document.createElement('script');
    script.src = 'https://elevenlabs.io/player/audioNativeHelper.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup quando il componente si smonta
      script.remove();
    };
  }, [widgetId]);

  return (
    <div ref={containerRef}>
      <div
        id="elevenlabs-audionative-widget"
        data-height={size === 'small' ? '90' : '120'}
        data-width="100%"
        data-frameborder="no"
        data-scrolling="no"
        data-publicuserid={publicUserId}
        data-playerurl="https://elevenlabs.io/player/index.html"
        data-small={size === 'small' ? 'True' : 'False'}
        data-textcolor={textColor}
        data-backgroundcolor={backgroundColor}
      />
    </div>
  );
};

export default ElevenLabsAudioNative;
